import React, { useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { usDate, usPhoneFormat} from "../../helpers";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
  whiteSpace: "nowrap"
};

export default function IncomingFidelisMessageDataTable(props) {
  const {
    tableData = [],
    setDataLoading = () => {},
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading
  } = props;

  const [orderBy, setOrderBy] = useState();

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] === name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };
  
  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th
                onClick={() => {
                  handleOrderChange("patient_name");
                }}
                className={
                  orderBy === "patient_name" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Name <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("practice_location");
                }}
                className={
                  orderBy === "practice_location" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Practice Location <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("phone_from");
                }}
                className={
                  orderBy === "phone_from" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("message_body");
                }}
                className={
                  orderBy === "message_body" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Message Body <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("created_at");
                }}
                className={orderBy === "created_at" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Receive Time <ChevronsUpDown size={"12"} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ whiteSpace: 'nowrap' }}>{item?.patient_name}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{item?.practice_location}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{usPhoneFormat(item?.phone_from)}</td>
                    <td>
                      <p style={{ marginBottom: '0' }} dangerouslySetInnerHTML={{ __html: (item?.message_body || "").replace(/\n/g, "<br/>") }}></p>
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>{usDate(item?.created_at)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan="5">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width={`${4 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
